import React from "react";

const STATS = [
  { big: "+1.900", label: "Alunos formados" },
  { big: "+50", label: "Aulas gravadas" },
  { big: "SIGO", label: "Certificação oficial" },
  { big: "14d", label: "Garantia total" },
];

export default function StatsBar() {
  return (
    <section className="lg:hidden bg-[#0A0A0A] border-b border-white/10" data-testid="stats-bar">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-2 gap-px bg-white/10">
        {STATS.map((s) => (
          <div
            key={s.label}
            className="bg-[#0A0A0A] p-6 flex flex-col gap-1"
          >
            <span className="font-display text-4xl text-yellow-400 leading-none">{s.big}</span>
            <span className="text-xs uppercase tracking-widest text-zinc-400 mt-2">{s.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
